var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
// キャンバス
import React, { useRef, useCallback, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { Stage, Layer, Line, Image as CanvasImage } from 'react-konva';
import { compressor_option, preview_option } from '../Const';
import PreviewModal from './PreviewModal';
var Canvas = function (_a) {
    var img_src = _a.img_src, disabled = _a.disabled, handleFinish = _a.handleFinish, block_disabled = _a.block_disabled, file_download = _a.file_download, file_name = _a.file_name, is_pdf = _a.is_pdf;
    var _b = React.useState([]), lines = _b[0], setLines = _b[1];
    var _c = React.useState(false), can_drawing = _c[0], setCanDrawing = _c[1];
    var _d = React.useState(false), is_drawing = _d[0], setIsDrawing = _d[1];
    var canvas_image = React.useState(new Image())[0];
    var _e = React.useState(0), canvas_width = _e[0], setCanvasWidth = _e[1];
    var _f = React.useState(0), canvas_heigth = _f[0], setCanvasHeight = _f[1];
    var _g = React.useState(disabled), is_disabled_button_masking = _g[0], setIsDisabledButtonMasking = _g[1];
    var _h = React.useState(true), is_disabled_button_reset = _h[0], setIsDisabledButtonReset = _h[1];
    var _j = React.useState(true), is_disabled_button_finish = _j[0], setIsDisabledButtonFinish = _j[1];
    var _k = React.useState(''), current_file_name = _k[0], setCurrentFileName = _k[1];
    var stageRef = useRef(null);
    var _l = React.useState(false), can_pinchIn = _l[0], setCanPinchIn = _l[1];
    var _m = React.useState(false), is_preview = _m[0], setIsPreview = _m[1];
    useEffect(function () {
        //コンポーネント表示中はタッチ操作でピンチインピンチアウトを無効化する。
        window.addEventListener('touchstart', handlePinchInStart);
        window.addEventListener('touchend', handlePinchInEnd);
        return function () {
            window.removeEventListener('touchstart', handlePinchInStart);
            window.removeEventListener('touchend', handlePinchInEnd);
        };
    }, []);
    React.useEffect(function () {
        if (is_pdf) {
            setIsDisabledButtonMasking(true);
        }
        else {
            setIsDisabledButtonMasking(disabled);
        }
        setIsDisabledButtonReset(true);
        setIsDisabledButtonFinish(true);
        setCanDrawing(false);
        setLines([]);
        canvas_image.onload = function () {
            //ファイルのサイズに応じてCanvasのサイズを設定する。
            //参照ボタン押下で別ファイルが読み込まれた場合
            if (file_name !== null && current_file_name !== file_name) {
                //読込んだ画像の横幅と縦幅を取得
                var result = { width: canvas_image.naturalWidth, height: canvas_image.naturalHeight };
                //横幅が縦幅より長い場合は横幅を圧縮時の最大サイズに設定し、縦幅をアスペクト比に応じて設定する。
                if (result.width >= result.height) {
                    var base_size = result.width <= compressor_option.preview_max_width
                        ? result.width
                        : compressor_option.preview_max_width;
                    var magnification = result.height / result.width;
                    result.width = base_size;
                    result.height = base_size * magnification;
                }
                else {
                    var base_size = result.height <= compressor_option.preview_max_height
                        ? result.width
                        : compressor_option.preview_max_height;
                    var magnification = result.width / result.height;
                    result.width = base_size * magnification;
                    result.height = base_size;
                }
                setCanvasWidth(result.width);
                setCanvasHeight(result.height);
                setCurrentFileName(file_name);
            }
        };
        canvas_image.src = img_src;
    }, [disabled, img_src]);
    /**
     * canvas描画イメージを取得する。
     * @return string canvas描画イメージのdataUrl
     */
    var getFile = function () {
        var _a, _b;
        //画像保存時のプレビュー画像の拡大倍率(拡大倍率は圧縮時の最大画像サイズ以内とする)
        var scale = canvas_image.naturalWidth > compressor_option.max_width
            ? compressor_option.max_width / canvas_width
            : canvas_image.naturalWidth / canvas_width;
        var image_file = (_b = (_a = stageRef.current) === null || _a === void 0 ? void 0 : _a.toDataURL({ pixelRatio: scale })) !== null && _b !== void 0 ? _b : '';
        return image_file;
    };
    /**
     * タッチ操作開始時のイベント
     */
    var handlePinchInStart = function (event) {
        var touches = event.touches;
        //ピンチイン操作の判定を行う。
        setCanPinchIn(touches.length > 1);
    };
    /**
     * タッチ操作終了時のイベント
     */
    var handlePinchInEnd = function (event) {
        //ピンチイン操作フラグを無効にする。
        setCanPinchIn(false);
    };
    /**
     * マスキング描画開始時のイベント
     * @param event タッチイベント | マウスイベント
     */
    var handleStart = function (event) {
        if (!can_drawing) {
            return;
        }
        setIsDrawing(true);
        var stage = event.target.getStage();
        if (stage !== null) {
            var point = stage.getPointerPosition();
            if (point !== null) {
                setLines(__spreadArray(__spreadArray([], lines), [[point.x, point.y]]));
            }
        }
    };
    /**
     * マスキング描画移動時のイベント
     * @param event タッチイベント | マウスイベント
     */
    var handleMove = function (event) {
        // no drawing - skipping
        if (!is_drawing) {
            return;
        }
        var stage = event.target.getStage();
        if (stage !== null) {
            var point = stage.getPointerPosition();
            if (point !== null) {
                var lastLine = lines[lines.length - 1].concat([point.x, point.y]);
                lines.splice(lines.length - 1, 1, lastLine);
                setLines(lines.concat());
            }
        }
    };
    /**
     * マスキング描画終了時のイベント
     */
    var handleEnd = function () {
        setIsDrawing(false);
        setCanPinchIn(false);
    };
    /**
     * マスキングボタン押下時のイベント
     */
    var handleMasking = function () {
        setCanDrawing(is_pdf ? false : !can_drawing);
        setIsDisabledButtonMasking(true);
        setIsDisabledButtonReset(false);
        setIsDisabledButtonFinish(false);
        setCanPinchIn(false);
    };
    /**
     * 確定ボタン押下時のイベント（活性・非活性・ボタン制御）
     */
    var handleFinishDisabled = useCallback(function () {
        setCanDrawing(false);
        setIsDisabledButtonMasking(false);
        setIsDisabledButtonReset(true);
        setIsDisabledButtonFinish(true);
    }, []);
    /**
     * リセットボタン押下時のイベント
     */
    var handleReset = function () {
        setLines([]);
    };
    /**
     * プレビュー画像押下時のイベント
     * @param file_name プレビュー表示およびダウンロードするファイル
     */
    var handlePreview = function (file_name) {
        // マスキング中またはダウンロード対象がpdfかファイル名がない場合は処理を終了する。
        if (can_drawing || is_pdf || !file_name) {
            return;
        }
        setIsPreview(true);
    };
    /**
     * プレビュー表示時の画像サイズを計算する。
     * @param image_width 棚に表示中の画像の横幅
     * @param image_height 棚に表示中の画像の縦幅
     * @return object プレビュー画像の縦横幅の設定値オブジェクト
     */
    var imageSize = function (image_width, image_height) {
        var result = { preview_width: 0, preview_height: 0 };
        // 比率決定
        var reduction_rate = window.innerWidth > 600 ? preview_option.reduction_rate_pc : preview_option.reduction_rate_sp;
        //プレビュー画像のサイズを設定する。
        if (image_width > image_height) {
            var tmp_size = window.innerHeight * reduction_rate;
            var base_size = window.innerWidth < tmp_size ? window.innerWidth * reduction_rate : tmp_size;
            result.preview_width = base_size;
            result.preview_height = base_size * (image_height / image_width);
        }
        else if (image_width < image_height) {
            var tmp_size = window.innerWidth * reduction_rate;
            var base_size = window.innerHeight < tmp_size ? window.innerHeight * reduction_rate : tmp_size;
            result.preview_width = base_size * (image_width / image_height);
            result.preview_height = base_size;
        }
        else {
            var tmp_size = window.innerWidth * reduction_rate;
            result.preview_width = tmp_size;
            result.preview_height = tmp_size;
        }
        return result;
    };
    /**
     * プレビューモーダルを非表示にする。
     */
    var handleClose = useCallback(function (event) {
        setIsPreview(false);
    }, []);
    return (React.createElement("div", null,
        React.createElement("div", { className: "d-inline-block mr-1 mt-1", onClick: function () { return handlePreview(file_download); } },
            can_drawing && !can_pinchIn && (React.createElement("div", { className: "preview-image" },
                React.createElement(Stage, { ref: stageRef, width: canvas_width, height: canvas_heigth, onMouseDown: handleStart, onMouseUp: handleEnd, onMouseMove: handleMove, onTouchStart: handleStart, onTouchEnd: handleEnd, onTouchMove: handleMove },
                    React.createElement(Layer, null,
                        React.createElement(CanvasImage, { image: canvas_image, width: canvas_width, height: canvas_heigth, x: 0, y: 0 }),
                        lines.map(function (line, i) { return (React.createElement(Line, { key: i, points: line, stroke: "black", strokeWidth: 8, tension: 0.5, lineCap: "round", globalCompositeOperation: 'source-over' })); }))))),
            (!can_drawing || can_pinchIn) && (React.createElement("img", { style: { width: canvas_width, height: canvas_heigth }, src: canvas_image.src, width: canvas_image.naturalWidth, height: canvas_image.naturalHeight }))),
        React.createElement("div", null, !block_disabled ? (React.createElement("div", null,
            React.createElement(Button, { className: "btn-shadow gradation", onClick: handleMasking, disabled: is_disabled_button_masking }, "\u30DE\u30B9\u30AD\u30F3\u30B0"),
            React.createElement(Button, { className: "btn-shadow gradation", onClick: handleReset, disabled: is_disabled_button_reset }, "\u30EA\u30BB\u30C3\u30C8"),
            React.createElement(Button, { className: "btn-shadow gradation", onClick: function () {
                    handleFinish(getFile());
                    handleFinishDisabled();
                }, disabled: is_disabled_button_finish }, "\u78BA\u5B9A"))) : (React.createElement(React.Fragment, null))),
        React.createElement(PreviewModal, { show: is_preview, image_source: canvas_image.src, image_width: imageSize(canvas_width, canvas_heigth).preview_width, image_height: imageSize(canvas_width, canvas_heigth).preview_height, handleOnclick: handleClose })));
};
export default Canvas;
